import { useMutation } from "@tanstack/react-query";
import FetchClients from "../client";

const terms = {
  mutations: {
    usePostAcceptAll,
  },
} as const;

export default terms;

/**
 * Accepts every outstanding policy in one transaction - there is no per-category
 * endpoint. Refetch the current user afterwards to confirm the write landed.
 */
export const acceptAllTerms = async () => {
  const { response, error } = await FetchClients.auth.POST("/terms/accept_all");
  if (response.ok) return;
  throw new Error(error);
};

function usePostAcceptAll() {
  return useMutation({ mutationFn: acceptAllTerms });
}
